import React, { useState } from 'react';
import { toast } from 'sonner';
import { ArrowRight, Ban, QrCode, Search } from 'lucide-react';
import { Button } from '../../components/Button';
import { Input } from '../../components/Input';
import { PageHeader } from '../../components/common/PageHeader';
import { Panel } from '../../components/common/Panel';
import { CngQrSticker } from '../../components/stickers/CngQrSticker';
import { usePrototype } from '../../contexts/PrototypeContext';
const reasons = ['স্টিকার নষ্ট', 'স্টিকার হারানো', 'QR পড়া যাচ্ছে না', 'গাড়ির কাচ পরিবর্তন', 'তথ্য পরিবর্তন', 'অন্যান্য'];
export function StickerReplacement() {
  const {
    cngList,
    replacements,
    addReplacement
  } = usePrototype();
  const [cngId, setCngId] = useState('c1');
  const [q, setQ] = useState('ঢাকা-থ-১১-১২৩৪');
  const [reason, setReason] = useState(reasons[2]);
  const [remark, setRemark] = useState('রোদে স্টিকারের রং উঠে যাওয়ায় মোবাইল অ্যাপে QR স্ক্যান হচ্ছে না।');
  const [step, setStep] = useState<0 | 1 | 2>(0);
  const cng = cngList.find(c => c.id === cngId);
  if (!cng) return null;
  const history = replacements[cng.id] ?? [];
  const currentQr = history[0]?.newQr && history[0].newQr !== cng.qrId && step === 0 ? history[0].newQr : cng.qrId;
  const newQr = `${cng.qrId}-R${history.length + 1}`;
  return <div data-id="element-3476" data-mp="2vz9hyz1kt38a">
      <PageHeader title="স্টিকার প্রতিস্থাপন" subtitle="পুরাতন QR বাতিল করে নতুন QR তৈরি — সম্পূর্ণ প্রতিস্থাপন ইতিহাস সংরক্ষিত" data-id="element-3477" data-mp="2w0klcxr408yv" />
      <Panel className="mb-4" data-id="element-3478" data-mp="28a6sx64m483r">
        <div className="flex flex-wrap items-end gap-3" data-id="element-3479" data-mp="248lgflvzpvu3">
          <div className="min-w-[280px] flex-1" data-id="element-3480" data-mp="24a6brdq4pit0">
            <label htmlFor="sr-q" className="mb-1 block text-xs font-medium text-slate-600" data-id="element-3481" data-mp="2i09sxqa5imbl">CNG Registration / QR ID</label>
            <div className="relative" data-id="element-3482" data-mp="2d7yqogrxuofv">
              <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-3483" data-mp="2d6x7fp0rqvn2" />
              <Input id="sr-q" value={q} onChange={e => setQ(e.target.value)} className="pl-9" data-id="element-3484" data-mp="1phcmx1oyvqbo" />
            </div>
          </div>
          <Button onClick={() => {
          const r = cngList.find(c => c.reg.includes(q.trim()) || c.qrId === q.trim());
          if (r && r.stage >= 7) {
            setCngId(r.id);
            setStep(0);
          } else toast.error('সক্রিয় স্টিকারসহ কোনো সিএনজি পাওয়া যায়নি');
        }} data-id="element-3485" data-mp="3kn3u3v04u4kx">
            খুঁজুন
          </Button>
        </div>
      </Panel>

      <div className="grid gap-4 xl:grid-cols-[1fr_1fr]" data-id="element-3486" data-mp="386vofidejqy">
        <Panel title="প্রতিস্থাপনের কারণ" data-id="element-3487" data-mp="31orgnx26u8jj">
          <div className="grid gap-2 sm:grid-cols-2" role="radiogroup" aria-label="কারণ" data-id="element-3488" data-mp="31q2oc7yr80fx">
            {reasons.map(r => <label key={r} className={`flex cursor-pointer items-center gap-2 rounded-md border px-3 py-2.5 text-sm ${reason === r ? 'border-navy-600 bg-navy-50 font-semibold text-navy-900' : 'border-border text-slate-700'}`} data-id="element-3489" data-mp="3ble3ushzlboq">
                <input type="radio" name="reason" checked={reason === r} onChange={() => setReason(r)} className="accent-navy-800" data-id="element-3490" data-mp="quwrgz44li34" />
                {r}
              </label>)}
          </div>
          <label htmlFor="sr-rm" className="mb-1 mt-4 block text-xs font-medium text-slate-600" data-id="element-3491" data-mp="2fe11ntyd131x">মন্তব্য</label>
          <textarea id="sr-rm" value={remark} onChange={e => setRemark(e.target.value)} rows={3} className="w-full rounded-md border border-input p-3 text-sm outline-none focus:border-navy-500" data-id="element-3492" data-mp="2be8wlr86df1b" />
          <div className="mt-4 flex flex-wrap gap-2" data-id="element-3493" data-mp="21ne96jj709ea">
            <Button variant="outline" disabled={step !== 0} className="border-red-200 text-red-700 hover:bg-red-50 hover:text-red-700" onClick={() => {
            setStep(1);
            toast.warning(`${currentQr} বাতিল — রোডসাইড স্ক্যানে “স্টিকার বাতিল” দেখাবে`);
          }} data-id="element-3494" data-mp="1wpcj3encn9tb">
              <Ban className="h-4 w-4" data-id="element-3495" data-mp="1noeoto2pqgnx" />১. পুরাতন QR বাতিল করুন
            </Button>
            <Button disabled={step !== 1} onClick={() => {
            addReplacement(cng.id, {
              date: '১২ মার্চ ২০২৬',
              oldQr: currentQr,
              newQr,
              reason,
              by: 'মোঃ সাজ্জাদ হোসেন'
            });
            setStep(2);
            toast.success(`নতুন QR তৈরি: ${newQr} — প্রিন্ট সারিতে যুক্ত`);
          }} data-id="element-3496" data-mp="1iqd28t62vz7p">
              <QrCode className="h-4 w-4" data-id="element-3497" data-mp="2er042esiix3z" />২. নতুন QR তৈরি করুন
            </Button>
          </div>
        </Panel>
        <Panel title="স্টিকার পরিবর্তন" data-id="element-3498" data-mp="20s0ft88wwk8c">
          <div className="flex flex-wrap items-center justify-center gap-4" data-id="element-3499" data-mp="20qz6p9bgi7t9">
            <div className="text-center" data-id="element-3500" data-mp="25pinkvb70ter">
              <p className="mb-2 text-xs font-semibold text-slate-500" data-id="element-3501" data-mp="25seo8refdw6w">পুরাতন</p>
              <CngQrSticker qrId={step === 2 ? history[0]?.oldQr ?? currentQr : currentQr} reg={cng.reg} size="sm" voided={step >= 1} data-id="element-3502" data-mp="1r0cvdrarw3gd" />
            </div>
            <ArrowRight className="h-6 w-6 text-slate-300" data-id="element-3503" data-mp="1i1iydztj5b2a" />
            <div className="text-center" data-id="element-3504" data-mp="1hz69t3t9o2g9">
              <p className="mb-2 text-xs font-semibold text-slate-500" data-id="element-3505" data-mp="1m1t7vmgj6jlw">নতুন</p>
              {step === 2 ? <CngQrSticker qrId={history[0]?.newQr ?? newQr} reg={cng.reg} size="sm" data-id="element-3506" data-mp="183uuaja1ar7g" /> : <div className="flex h-[250px] w-[150px] items-center justify-center rounded-xl border-2 border-dashed border-slate-300 text-xs text-slate-400" data-id="element-3507" data-mp="1d0lb58tnxqtx">তৈরি হয়নি</div>}
            </div>
          </div>
        </Panel>
      </div>

      <Panel title={`প্রতিস্থাপন ইতিহাস — ${cng.reg}`} className="mt-4" bodyClassName="p-0" data-id="element-3508" data-mp="13eahqjhgcdix">
        <table className="w-full text-sm" data-id="element-3509" data-mp="yf7dv2d7kdcj">
          <thead className="bg-slate-50 text-left text-xs text-slate-500" data-id="element-3510" data-mp="ye65j5nku4yi"><tr data-id="element-3511" data-mp="1cep7bv1g8es8">{['তারিখ', 'পুরাতন QR', 'নতুন QR', 'কারণ', 'সম্পাদনকারী'].map(h => <th key={h} className="px-4 py-2.5 font-medium" data-id="element-3512" data-mp="1ccvxk6vjheg0">{h}</th>)}</tr></thead>
          <tbody data-id="element-3513" data-mp="17fckhaakv7pn">
            {history.map((h, i) => <tr key={i} className="border-t border-border" data-id="element-3514" data-mp="1m5bgp7iko92h" data-mpi={i}>
                <td className="px-4 py-3" data-id="element-3515" data-mp="1m6mkv8fxjiu4">{h.date}</td>
                <td className="px-4 py-3 font-mono text-xs text-red-700 line-through" data-id="element-3516" data-mp="1h6qgv978frek">{h.oldQr}</td>
                <td className="px-4 py-3 font-mono text-xs font-semibold text-emerald-700" data-id="element-3517" data-mp="1v6i0bpgipzzy">{h.newQr}</td>
                <td className="px-4 py-3" data-id="element-3518" data-mp="1r56779yfqwn0">{h.reason}</td>
                <td className="px-4 py-3" data-id="element-3519" data-mp="1y7bexvchqse6">{h.by}</td>
              </tr>)}
            {history.length === 0 && <tr data-id="element-3520" data-mp="235moe4yvj0vv"><td colSpan={5} className="px-4 py-6 text-center text-slate-500" data-id="element-3521" data-mp="235mpy9eiv8xz">কোনো প্রতিস্থাপন ইতিহাস নেই</td></tr>}
          </tbody>
        </table>
      </Panel>
    </div>;
}